import { z } from "zod/v4";

import { CampaignWithIdSchema } from "../../../dtos/deprecated/campaigns";

export const ArchiveCampaignRequestPathParamSchema = z.object({
  campaignId: z.uuid(),
});

export type ArchiveCampaignRequestPathParamType = z.infer<
  typeof ArchiveCampaignRequestPathParamSchema
>;

export const ArchiveCampaignResponseBodySchema = z.object({
  campaigns: CampaignWithIdSchema.array(),
});

export type ArchiveCampaignResponseBodyType = z.infer<
  typeof ArchiveCampaignResponseBodySchema
>;
